




import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import { colors } from '@/config';
import { highchartsSpacing } from '@/utils/chartPresentationSizing';
import vue from 'vue';

More(Highcharts);

@Component({components: {Chart}})
export default class ProfitLoss extends Vue {
  @Prop() readonly balance!: any;
  @Prop() dark!: boolean;
  @Prop() containerWidth: any;
  @Prop() currentLanguage: any;

  chartOptions: any = {};

  update() {
  this.$nextTick(() => {
    const chart = this.$refs.chart as any;
    if (chart && chart.chart) {
      chart.chart.reflow();
    }
  });

  this.chartOptions = {
    chart: {
      type: 'waterfall',
      backgroundColor: 'transparent',
      ...highchartsSpacing(this.containerWidth),
    },

    credits: {
      enabled: false,
    },

    title: {
      text: '',
    },

    xAxis: {
      type: 'category',
      labels: {
        autoRotation: [0],
        staggerLines: 1,
        padding: this.transformPx(10),
        style: {
          fontSize: '1cqw',
          textOverflow: 'none',
          whiteSpace: 'normal',
          color: this.dark ? colors.Light : colors.Black,
        },
      },
    },

    yAxis: {
      title: {
        text: '',
      },
      labels: {
        style: {
          fontSize: this.dark ? '1cqw' : '1cqw',
          color: this.dark ? colors.Light : colors.Black,
        },
        formatter() { return (vue as any).options.filters.KR((this as any).value); },
      },
      tickPixelInterval: this.dark ? this.transformPx(200) : 150,
      gridLineColor: this.dark ? colors.Black : colors.LightGrey,
      plotLines: [{
        color: colors.Black,
        width: this.dark ? this.transformPx(3) : 2,
        value: 0,
        zIndex: 20,
      }],
    },

    legend: {
      enabled: false,
    },

    tooltip: {
      // headerFormat: '',
      // pointFormat: '<span>{point.subname}: <b>{point.y:,.0f} tkr</b></span>',
      formatter(): any {
        return (this as any).point.subname + ' ' + ' ' + (vue as any).options.filters.TKR((this as any).point.y);
      },
      style: {
        fontSize: '1.5cqw',
        color: this.dark ? colors.Light : colors.Black,
      },
      backgroundColor: this.dark ? colors.Dark : colors.Light,
    },

  series: this.getSeries(),
  };
}

  mounted() {
    this.update();
  }

  @Watch('balance', {immediate: false, deep: true})
  balanceChanged() {
    this.update();
  }

  @Watch('containerWidth', {immediate: false, deep: true})
  containerWidthChanged() {
    this.update();
  }

  getSeries() {
    return [{
      upColor: this.dark ? colors.Secondary : colors.Primary,
      color: colors.Tertiary,
      lineColor: this.dark ? colors.Black : colors.DarkGrey,
      borderColor: this.dark ? colors.Black : colors.DarkGrey,
      data: [
        {
          name: this.currentLanguage === 'en' ? 'Capital subscribed but not paid up' : Vue.prototype.$t('Tecknat, men ej inbetalt kapital'),
          subname: this.currentLanguage === 'en' ? 'Capital subscribed but not paid up' : Vue.prototype.$t('Tecknat, men ej inbetalt kapital'),
          y: this.balance.A,
        }, {
          name: this.currentLanguage === 'en' ? 'Fixed assets' : Vue.prototype.$t('Anläggnings-tillgångar'),
          subname: this.currentLanguage === 'en' ? 'Intangible' : Vue.prototype.$t('Immateriella'),
          y: this.balance.B,
        }, {
          name: this.currentLanguage === 'en' ? 'Fixed assets' : Vue.prototype.$t('Anläggnings-tillgångar'),
          subname: this.currentLanguage === 'en' ? 'Tangible' : Vue.prototype.$t('Materiella'),
          y: this.balance.C,
        }, {
          name: this.currentLanguage === 'en' ? 'Fixed assets' : Vue.prototype.$t('Anläggnings-tillgångar'),
          subname: this.currentLanguage === 'en' ? 'Financial' : Vue.prototype.$t('Finansiella'),
          y: this.balance.D,
        }, {
          name: this.currentLanguage === 'en' ? 'Stock' : Vue.prototype.$t('Varulager'),
          subname: this.currentLanguage === 'en' ? 'Stock' : Vue.prototype.$t('Varulager'),
          y: this.balance.F,
        }, {
          name: this.currentLanguage === 'en' ? 'Other Current assets' : Vue.prototype.$t('Övriga omsättnings-tillgångar'),
          subname: this.currentLanguage === 'en' ? 'Accounts receivable' : Vue.prototype.$t('Kundfordringar'),
          y: this.balance.G,
        }, {
          name: this.currentLanguage === 'en' ? 'Other Current assets' : Vue.prototype.$t('Övriga omsättnings-tillgångar'),
          subname: this.currentLanguage === 'en' ? 'Other short-term receivables' : Vue.prototype.$t('Övriga kortfristiga fordringar'),
          y: this.balance.H,
        }, {
          name: this.currentLanguage === 'en' ? 'Other Current assets' : Vue.prototype.$t('Övriga omsättnings-tillgångar'),
          subname: this.currentLanguage === 'en' ? 'Short term investments' : Vue.prototype.$t('Kortfristiga placeringar'),
          y: this.balance.I,
        }, {
          name: this.currentLanguage === 'en' ? 'Other current assets' : Vue.prototype.$t('Övriga omsättnings-tillgångar'),
          subname: this.currentLanguage === 'en' ? 'Cash' : Vue.prototype.$t('Kassa och bank'),
          y: this.balance.J,
        }, {
          name: this.currentLanguage === 'en' ? 'Total assets' : Vue.prototype.$t('Balans-omslutning'),
          subname: this.currentLanguage === 'en' ? 'Total assets' : Vue.prototype.$t('Balansomslutning'),
          isIntermediateSum: true,
          color: colors.DarkGrey,
        }, {
          name: this.currentLanguage === 'en' ? 'Current liabilities' : Vue.prototype.$t('Kortfristiga skulder'),
          subname: this.currentLanguage === 'en' ? 'Current liabilities' : Vue.prototype.$t('Kortfristiga skulder'),
          y: -this.balance.Q,
        }, {
          name: this.currentLanguage === 'en' ? 'Long-term liabilities' : Vue.prototype.$t('Långfristiga skulder'),
          subname: this.currentLanguage === 'en' ? 'Long-term liabilities' : Vue.prototype.$t('Långfristiga skulder'),
          y: -this.balance.P,
        }, {
          name: this.currentLanguage === 'en' ? 'Provisions' : Vue.prototype.$t('Avsättningar'),
          subname: this.currentLanguage === 'en' ? 'Provisions' : Vue.prototype.$t('Avsättningar'),
          y: -this.balance.O,
        }, {
          name: this.currentLanguage === 'en' ? 'Equity' : Vue.prototype.$t('Eget kapital'),
          subname: this.currentLanguage === 'en' ? 'Accrural funds' : Vue.prototype.$t('Obeskattade reserver'),
          y: -this.balance.N,
          color: colors.LightGrey,
        }, {
          name: this.currentLanguage === 'en' ? 'Equity' : Vue.prototype.$t('Eget kapital'),
          subname: this.currentLanguage === 'en' ? 'Equity' : Vue.prototype.$t('Eget kapital'),
          isSum: true,
          color: colors.Green,
          negativeColor: colors.Red,
        },
      ].filter( (o, i) => o.y !== 0 || (i > 0  && i !== 12) ),

      pointPadding: 0,
    }];
  }

  transformPx(value: any) {
    if ( value * (this.containerWidth / 1920) < 1 ) {
      return 1;
    }
    return value * (this.containerWidth / 1920);
  }


}
